import { createReducer } from "@reduxjs/toolkit";

import { TYPES } from "../../common/constants";
import { fetchServiceRequestById } from "../actions/serviceRequest";

const fetchServiceRequestByIdDone = (serviceRequest, { payload }) => {
  if (serviceRequest.activity && serviceRequest.activity.length > 0) {
    return {
      ...payload,
      ...serviceRequest,
    };
  } else {
    return {
      ...payload,
      ...serviceRequest,
    };
  }
};

const UpdateServiceRequestDone = (serviceRequest, { payload }) => {
  return {
    ...serviceRequest,
    attachment: payload.attachment,
  };
};

const fetchServiceRequestActivityByIdDone = (serviceRequest, { payload }) => {
  let sr = serviceRequest;
  sr.activity = payload;
  return sr;
};

const saveStatusDone = (serviceRequest, { id, payload }) => {
  return {
    ...payload,
  };
};

// const saveServiceRequestDone = (serviceRequest, { payload }) => {
//   return {
//     ...payload,
//   };
// };

const fetchServiceRequestDocumentsDone = (serviceRequest, { payload }) => {
  return {
    ...serviceRequest,
    documents: payload.documents,
  };
};

const fetchServiceRequestNotesDone = (serviceRequest, { payload }) => {
  return {
    ...serviceRequest,
    notes: payload.notes,
  };
};

const updateWarrantyIssueStatusAndLoading = (serviceRequest, { payload }) => {
  return {
    ...serviceRequest,
    oneYearWarrantyIssues:payload.oneYearWarrantyIssues,
    loading:payload.loading
  };
};

const clearServiceRequestDone = () => {
  return initialState;
};

const initialState = {
  oneYearWarrantyIssues:null,
  loading:false,
};

export default createReducer(initialState, {
  // [TYPES.SAVE_SERVICE_REQUEST_DONE]: saveServiceRequestDone,
  [TYPES.FETCH_SERVICE_REQUEST_BY_ID_DONE]: fetchServiceRequestByIdDone,
  [TYPES.FETCH_SERVICE_REQUEST_ACTIVITY_BY_ID_DONE]:
    fetchServiceRequestActivityByIdDone,
  [TYPES.SAVE_STATUS_DONE]: saveStatusDone,
  [TYPES.FETCH_SERVICE_REQUEST_DOCUMENTS_DONE]:
    fetchServiceRequestDocumentsDone,
  [TYPES.FETCH_SERVICE_REQUEST_NOTES_DONE]: fetchServiceRequestNotesDone,
  [TYPES.CLEAR_SERVICE_REQUEST]: clearServiceRequestDone,
  [TYPES.UPDATE_SERVICE_REQUEST_DONE]: UpdateServiceRequestDone,
  [TYPES.UPDATE_WARRANTY_ISSUE_STATUS_AND_LOADING]:updateWarrantyIssueStatusAndLoading
});
